import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// TODO: Provide a sensible implementation
import * as React from "react";
import { LinkButton } from "./library/button";
export class Error extends React.Component {
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: "container--sg align--center",
            children: /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "error__wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            className: "title--xl",
                            children: "Helaas"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "error__text",
                            children: "Deze pagina kan niet worden getoond."
                        }),
                        /*#__PURE__*/ _jsx(LinkButton, {
                            route: "/",
                            arrow: true,
                            children: "Terug naar de homepage"
                        })
                    ]
                })
            })
        });
    }
    constructor(props){
        super(props);
    }
}
{}export const DNBErrorElement = /*#__PURE__*/ _jsx(Error, {});
